import React  from 'react';
import Helper from "../functions/Helper.js";
import styled from '@emotion/styled'
/** @jsx jsx */
import {jsx} from '@emotion/core'


const PickerCell = styled.div(props=>{
  let active=props.activeRating===props.rating;
  return({
    width:props.cellWidth,
    textAlign:"center",
    border:"1px solid #ccc",
    borderWidth:active ? 0 : "1px",
    marginLeft:-1,
    marginTop:10,
    fontSize:14,
    padding:8,
    cursor:"pointer",
    fontWeight: active ? 600: 500,
    color:active ? "white" : "#333",
    backgroundColor: active ? props.getColor(props.rating) : "transparent",
    outline:active ? "2px solid " +props.getColor(props.rating) :"none",
    zIndex:active ? 100 :1,
    //color:"white",
    //backgroundColor:Helper.get_color(props.rating,"bg"),
    "&:hover":{
      fontWeight: 600,
      color:"white",
      backgroundColor:props.getColor(props.rating)
    },
    ...props.style
  })
});

export default function Picker(props){
  return(
    <div css={{paddingLeft:1,display:"flex",flexWrap:"wrap"}}>
      {props.values.map((option,index)=>
        <PickerCell
          key={index}
          cellWidth={ props.hasOwnProperty("getCellWidth") ? props.getCellWidth(option) : option.rating==="NA"? 60 :  110}
          getColor={props.getColor}
          activeRating={props.activeRating}
          onClick={()=>props.changeRating(option.rating)}
          rating={option.rating}>
          {option.label}
        </PickerCell>
      )}
    </div>
  )
}
